import React, { createContext, useContext, useMemo, useState } from 'react'
import {
  templatesQueries,
  TemplateStepType,
  TemplateStepsContextType,
  TemplateStepsProviderProps,
  TemplateStepParamKey,
} from '@/features/templates'
import { useSuspenseQuery } from '@tanstack/react-query'

const TemplateStepsContext = createContext<TemplateStepsContextType | undefined>(undefined)

export const TemplateStepsProvider = ({ children, templateId }: TemplateStepsProviderProps) => {
  const {
    data: { template },
  } = useSuspenseQuery(templatesQueries.detail(templateId))
  const [currentStep, setCurrentStep] = useState(0)

  const steps = useMemo(() => {
    const steps: TemplateStepType[] = []

    template.requirements?.connectors?.forEach((requirement) =>
      steps.push({
        type: 'connector',
        data: requirement,
      })
    )

    template.requirements?.secrets?.forEach((requirement) =>
      steps.push({
        type: 'secret',
        data: requirement,
      })
    )

    template.requirements?.params?.forEach((requirement) =>
      steps.push({
        type: requirement.type as TemplateStepParamKey,
        data: requirement,
      })
    )

    steps.push({
      type: 'summary',
    })

    return steps
  }, [template])

  const value = { steps, currentStep, setCurrentStep }

  return (
    <TemplateStepsContext.Provider value={value}>
      {typeof children === 'function' ? children(value) : children}
    </TemplateStepsContext.Provider>
  )
}

export const useTemplateStepsContext = () => {
  const context = useContext(TemplateStepsContext)
  if (!context) {
    throw new Error('useTemplateStepsContext must be used within a TemplateStepsProvider')
  }
  return context
}
